import { useRef } from 'react';

const useDebounce = <T extends unknown[]>(
  callback: (...args: T) => void,
  delayMs: number
): ((...args: T) => void) => {
  const argsRef = useRef<T>();
  const timeoutId = useRef<number>();

  return (...args: T) => {
    argsRef.current = args;

    if (timeoutId.current) window.clearTimeout(timeoutId.current);

    timeoutId.current = window.setTimeout(() => {
      if (argsRef.current) callback(...argsRef.current);
    }, delayMs);
  };
};

export default useDebounce;
